export const WS_TIMEZONE_KEY = 'ws_timezone';

export const DEFAULT_TIMEZONE = 'America/Guayaquil';

export const TIMEZONE_OPTIONS = [
  { value: 'America/Guayaquil', label: 'GYE Ecuador (America/Guayaquil)', country: 'Ecuador', city: 'Guayaquil', short: 'GYE' },
  { value: 'America/Bogota', label: 'Bogota Colombia (America/Bogota)', country: 'Colombia', city: 'Bogota', short: 'BOG' },
  { value: 'America/Lima', label: 'Lima Peru (America/Lima)', country: 'Peru', city: 'Lima', short: 'LIM' },
  { value: 'America/Mexico_City', label: 'Ciudad de Mexico (America/Mexico_City)', country: 'Mexico', city: 'Ciudad de Mexico', short: 'CDMX' },
  { value: 'America/Santiago', label: 'Santiago Chile (America/Santiago)', country: 'Chile', city: 'Santiago', short: 'SCL' },
  { value: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires (America/Argentina/Buenos_Aires)', country: 'Argentina', city: 'Buenos Aires', short: 'BUE' },
  { value: 'America/New_York', label: 'New York (America/New_York)', country: 'USA', city: 'New York', short: 'NYC' },
  { value: 'Europe/Madrid', label: 'Madrid Espana (Europe/Madrid)', country: 'Espana', city: 'Madrid', short: 'MAD' },
];

const optionMap = new Map(TIMEZONE_OPTIONS.map((option) => [option.value, option]));

export function getTimezoneMeta(timezoneValue) {
  const tz = String(timezoneValue || '').trim();
  return optionMap.get(tz) || optionMap.get(DEFAULT_TIMEZONE);
}

export function getUserTimezone() {
  try {
    const raw = String(localStorage.getItem(WS_TIMEZONE_KEY) || '').trim();
    if (optionMap.has(raw)) return raw;
  } catch (_) {
    // ignore read errors
  }
  return DEFAULT_TIMEZONE;
}

export function setUserTimezone(timezoneValue) {
  const tz = optionMap.has(String(timezoneValue || '').trim())
    ? String(timezoneValue).trim()
    : DEFAULT_TIMEZONE;

  try {
    localStorage.setItem(WS_TIMEZONE_KEY, tz);
    window.dispatchEvent(new CustomEvent('ws:timezone_changed', { detail: { timezone: tz } }));
  } catch (_) {
    // ignore write errors
  }

  return tz;
}

export function ensureUserTimezone() {
  const tz = getUserTimezone();
  setUserTimezone(tz);
  return tz;
}

export function formatClockInTimezone(date, timezoneValue) {
  const tz = optionMap.has(String(timezoneValue || '').trim()) ? String(timezoneValue).trim() : DEFAULT_TIMEZONE;
  try {
    return new Intl.DateTimeFormat('es-EC', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(date);
  } catch (_) {
    return '--:--:--';
  }
}
